import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';

import CommonHeaderComponent from '../headers/CommonHeaderComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PictureModeModal from '../core/PictureModeModal';
import ConfirmationModal from '../core/ConfirmationModal';
import IssueConfirmedModal from '../core/IssueConfirmedModal';
import * as symbols from '../../operations/symbols';
import * as actions from '../../actions/ordersAction';
import './reason.scss';

const storeCloseReason = "storeClose";
const storeNotFoundReason = "storeNotFound";
const duplicateOrder = "duplicateOrder";
const otherReason = "others";

class ReasonList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reasonsList: {},
      currentOrder: null,
      reasonListModel: [{
          subtype: storeCloseReason,
          type: ['contact', 'photo'],
          contactMessage: '<b>Call restaurant</b> to confirm it is closed',
          photoMessage: "<b> Incase they do not respond</b><br />Take a selfie outside the restaurant to confirm that it's closed."
        },
        {
          subtype: storeNotFoundReason,
          type: ['contact', 'cancel'],
          contactMessage: 'Check that you are at the right restaurant',
          cancelMessage: '<b> Or</b><br />Confirm that you want to <b>re-attempt delivery for this order</b>'
        },
        {
          subtype: duplicateOrder,
          type: ['popUp'],
          cancelMessage: 'Confirm cancellation of the order'
        },
        {
          subtype: otherReason,
          type: ['direct-confirm'],
          reattemptMessgae: 'Do you want to confirm <span class="red-text">re-attempt delivery</span> of this order?'
        }
      ],
      openPictureModeModal: false,
      openDoneModal: false,
      openLoader: false,
      openConfirmationModal: false,
      commentMessage: ''
    }
  }

  componentDidMount() {
    if (!this.props.orders.deliveryReasons) {
      this.props.history.push('/');
      return
    }

    const orderId = this.props.match.params.orderId;

    let reasonsList = this.props.orders.deliveryReasons.reduce((acc, ele) => {
      acc[ele.id] = ele.name;
      return acc
    }, {})

    const currentOrder = this.props.orders && this.props.orders.orders.reduce((acc, ele, index) => {
      if (ele.orderId == orderId) {
        acc = ele
      }
      return acc

    }, {})
    this.setState({ reasonsList, currentOrder });
  }

  componentDidUpdate(prevProps) {
    const { cancelDeliveryIssueStatus } = this.props;
    if (cancelDeliveryIssueStatus !== prevProps.cancelDeliveryIssueStatus && (cancelDeliveryIssueStatus === symbols.STATUS_DONE)) {
      this.setState({ openDoneModal: true, openPictureModeModal: false, openConfirmationModal: false })
    }

    if (cancelDeliveryIssueStatus !== prevProps.cancelDeliveryIssueStatus && (cancelDeliveryIssueStatus === symbols.STATUS_FAIL)) {
      this.setState({ openLoader: false })
    }
  }


  renderContactCard(reasonType, ele) {
    if (this.state.currentOrder) {
      return (
        <div className="contact-card">
          <span className="try">Try this 👉</span>
          <br/>
          <span dangerouslySetInnerHTML={{ __html: ele.contactMessage }}></span>
          {
            reasonType == storeNotFoundReason &&
            <b>&nbsp; {this.state.currentOrder && this.state.currentOrder.outletAddress}</b>
          }
          {
            this.state.currentOrder.phones.length > 0 &&
            <a href={`tel:${this.state.currentOrder.phones[this.state.currentOrder.phones.length - 1].phoneNumber}`}>
              <div className="btn btn-green btn-expand btn-normal mt-2"><FontAwesomeIcon className="reverse" icon="phone" />&nbsp; Call restaurant</div>
            </a>
          }
        </div>
      )
    }
    return
  }

  // Modal operations
  closePictureModeModal() {
    this.setState({ openPictureModeModal: false })
  }

  openPictureModeModal() {
    this.setState({ openPictureModeModal: true })
  }


  // Modal operations
  closeConfirmationModal() {
    this.setState({ openConfirmationModal: false })
  }

  openConfirmationModal() {
    this.setState({ openConfirmationModal: true })
  }

  // cancel delivery
  cancelOrderDelivery(type) {
    const reasonId = this.props.match.params.reasonId;
    const orderId = this.props.match.params.orderId;
    const params = new FormData();
    params.append('reasonId', reasonId);
    if (this.state.commentMessage !== '') {
      params.append('comment', this.state.commentMessage);
    }
    this.setState({ openLoader: true })
    this.props.actions.cancelOrderDelivery(orderId, params);
  }

  componentWillUnmount() {
    this.props.actions.resetCancelDeliverySatuses();
  }

  render() {
    const { orders } = this.props;
    const reasonId = this.props.match.params.reasonId;
    const reasonType = this.props.match.params.reasonType;
    const orderId = this.props.match.params.orderId;
    const { reasonsList, openPictureModeModal, closePictureModeModal, openConfirmationModal, openDoneModal } = this.state;

    return (
      <div className="hp-container pd-top-global">
        <CommonHeaderComponent
          enableBack={true}
          icon={'times'}
          title={Object.keys(reasonsList).length > 0 && reasonsList[reasonId]}
        />
        <PictureModeModal
          isOpen={openPictureModeModal}
          closePictureModeModal={() => this.closePictureModeModal()}
          id={reasonId}
          type="reason"
          hasNotWrapper={true}
          redirectedURL={`/order/${orderId}/reason/${reasonId}/${reasonType}/photo`}
        />
        <ConfirmationModal
          isOpen={openConfirmationModal}
          closeConfirmationModal={() => this.closeConfirmationModal()}
          cancelOrderDelivery={() => this.cancelOrderDelivery()}
          openLoader={this.state.openLoader}
          error={this.props.cancelDeliveryIssueError ? this.props.cancelDeliveryIssueError.error : null}
        />
        <IssueConfirmedModal
          history={this.props.history}
          isOpen={openDoneModal}
          reasonsList={reasonsList}
          reasonId={reasonId}
        />
        <div className="reason-wrapper">
        {this.state.reasonListModel.map((ele, index) => {
          if(ele.subtype == reasonType){
            return(
              <React.Fragment key={index}>
                {
                  ele.type.map((typeEle, index) => {
                    return(
                      <div key={index} className="reason-card">
                        {
                          typeEle == 'contact' && this.renderContactCard(reasonType, ele)
                        }
                        {
                          typeEle == 'photo' &&
                          <div className="photo-card">
                            <div dangerouslySetInnerHTML={{ __html: ele.photoMessage }}></div>
                            <div className="center relative">
                              <h5 className="gray-text">Sample Photo </h5>
                              <img src="../../../../images/sample.png"/>
                              <img src="../../../../images/Ellipse.png" className="absolute-sample"/>
                            </div>
                            <div className="btn btn-transparent-green btn-expand btn-normal mt-2" onClick={() => this.openPictureModeModal()}><FontAwesomeIcon icon="camera" />&nbsp; Click photo</div>
                          </div>
                        }
                        {
                          typeEle == 'cancel' &&
                          <div className="contact-card">
                          <div dangerouslySetInnerHTML={{ __html: ele.cancelMessage }}></div>
                            
                            <div className="btn btn-transparent-red btn-expand btn-normal mt-2" onClick={() => this.cancelOrderDelivery()}>Re-attempt Delivery</div>
                          </div>
                        }
                        {
                          typeEle === 'popUp' && 
                          <div className="contact-card">
                          <div dangerouslySetInnerHTML={{ __html: ele.cancelMessage }}></div>
                            <div className="btn btn-transparent-red btn-expand btn-normal mt-2" onClick={() => this.cancelOrderDelivery()}>Cancel Order</div>
                          </div>
                        }
                        {
                          typeEle === 'direct-confirm' && 
                          <div className="contact-card">
                          <div dangerouslySetInnerHTML={{ __html: ele.reattemptMessgae }}></div>
                            <div className="btn btn-transparent-red btn-expand btn-normal mt-2" onClick={() => this.cancelOrderDelivery()}>Re-Attemt Delivery</div>
                          </div>
                        }
                        {/* {
                          typeEle == 'comments' &&
                          <div className="contact-card">
                            <div dangerouslySetInnerHTML={{ __html: ele.commentMessage }}></div>
                            <form className="mt-2">
                              <textarea placeholder="Add Issue" value={this.state.commentMessage} onChange={(e) => this.setState({commentMessage: e.target.value })}></textarea>
                              <div 
                                className={this.state.commentMessage.trim() === '' ? "btn-disabled btn btn-green btn-expand btn-normal mt-1" : "btn btn-green btn-expand btn-normal mt-1"}
                                onClick={() => this.openConfirmationModal()}
                              >
                                Re-Attempt Delivery
                              </div>
                            </form>
                          </div>
                        } */}
                      </div>
                    )
                  })
                }
                Incase of any issue feel free to <span className="blue-text"><FontAwesomeIcon icon="phone" className="reverse" /> <a href={`tel:+911171565093`}>Call us</a></span>
              </React.Fragment>
            )
          }
        })}
        </div>
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    cancelDeliveryIssueStatus: state.statuses.cancelDeliveryIssue.status,
    cancelDeliveryIssueError: state.statuses.cancelDeliveryIssue.errors,
    orders: state.orders
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(ReasonList));
